import React, { useEffect, useRef } from "react";
import Slider, { Settings } from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Button, Grid, Typography } from "@mui/material";
import AppWrapperContainer from "../../components/AppWrapperContainer";
import AboutUsBg from "../../public/assets/images/home/more/about-us/AboutUsBg.webp";
import {
  INVESTORS_IMAGES,
  INVESTOR_ICONS,
  RECORD_LIST,
  TEAM_CARDS,
} from "../../data/StaticList";
import Ankit from "../../public/assets/images/home/more/about-us/Ankit.webp";
import gromoTeam from "../../public/assets/images/home/more/about-us/gromoTeam.webp";
import openPositionBg from "../../public/assets/images/home/more/about-us/openPositionBg.webp";
import Image from "next/image";
import AppFooter from "../../components/AppFooter";
import Link from "next/link";
import Seo from "../../components/Seo";

function AboutUs() {
  const investorsIconsRef = useRef<Slider | null>(null);
  const investorsImagesRef = useRef<Slider | null>(null);

  const settings: Settings = {
    dots: true,
    infinite: false,
    autoplaySpeed: 4000,
    speed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    arrows: true,
    className: "teamsCard-dots",
  };
  const settingsInvestorsIcon: Settings = {
    infinite: false,
    speed: 2000,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    arrows: true,
    initialSlide: 0,
    rtl: false,
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const settingsInvestorImage: Settings = {
    infinite: false,
    speed: 2000,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    arrows: true,
    initialSlide: 0,
    rtl: false,
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  useEffect(() => {
    investorsIconsRef.current?.slickGoTo(0, true);
    investorsImagesRef.current?.slickGoTo(0, true);

    const tick = (ref: React.RefObject<Slider | null>, itemCount: number) => {
      const slider: any = ref.current;
      const inner = slider?.innerSlider;
      if (!inner) return;

      const current: number = inner.state?.currentSlide ?? 0;
      const show: number = inner.props?.slidesToShow ?? 1;
      const lastIndex = Math.max(0, itemCount - show);

      if (current >= lastIndex) {
        ref.current?.slickGoTo(0, true);
      } else {
        ref.current?.slickNext();
      }
    };

    const iconsInterval = window.setInterval(() => {
      tick(investorsIconsRef, INVESTOR_ICONS.length);
    }, 4000);

    const imagesInterval = window.setInterval(() => {
      tick(investorsImagesRef, INVESTORS_IMAGES.length);
    }, 4500);

    return () => {
      window.clearInterval(iconsInterval);
      window.clearInterval(imagesInterval);
    };
  }, []);

  const settingsRecord: Settings = {
    dots: true,
    infinite: false,
    autoplaySpeed: 4000,
    speed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    arrows: true,
  };
  return (
    <>
      <Seo
        title="About GroMo | Founded by IIT Delhi Alumni | Y Combinator Backed | 60L+ Partners"
        description="Learn about GroMo—India’s largest financial product distribution platform—our mission, team, and the story behind 60L+ partners earning by selling financial products."
        keywords="About GroMo, GroMo founders, GroMo mission, financial product distribution platform, fintech India"
        openGraph={{
          title:
            "About GroMo | India’s Largest Financial Product Distribution Platform | 60L+ Partners",
          description:
            "Become a partner and make a regular income by selling financial products. Brand yourself as a certified financial advisor and launch and grow your business.",
          type: "website",
          image:
            "https://elasticbeanstalk-ap-south-1-812175807951.s3.ap-south-1.amazonaws.com/static-resources/notification-resources/notification_images/1668084562_Meta+Image-low+size.webp",
          url: "https://gromo.in/about-us",
        }}
        twitter={{
          title:
            "About GroMo | India’s Largest Financial Product Distribution Platform | 60L+ Partners",
          description:
            "Become a partner and make a regular income by selling financial products. Brand yourself as a certified financial advisor and launch and grow your business.",
          url: "https://gromo.in/about-us",
          image:
            "https://elasticbeanstalk-ap-south-1-812175807951.s3.ap-south-1.amazonaws.com/static-resources/notification-resources/notification_images/1668084562_Meta+Image-low+size.webp",
        }}
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "AboutPage",
            "@id": "https://gromo.in/about-us#aboutpage",
            url: "https://gromo.in/about-us",
            name: "About GroMo",
            about: { "@id": "https://gromo.in/#organization" },
            isPartOf: { "@id": "https://gromo.in/#website" },
          },
        ]}
      />
      <AppWrapperContainer nav navBgColor="#002561">
        <>
          <Grid
            sx={{
              minHeight: { xs: "70vh", md: "80vh" },
              position: "relative",
            }}
          >
            <Grid
              sx={{
                display: "flex",
                justifyContent: { xs: "center", md: "flex-end" },
                alignItems: "center",
                flexDirection: "column",
                minHeight: { xs: "40vh", md: "30vh" },
                zIndex: 2,
              }}
            >
              <Typography
                sx={{
                  fontSize: { xs: "16px", md: "20px" },
                  lineHeight: { xs: "24px", md: "32px" },
                  fontWeight: "600",
                  background:
                    "linear-gradient(92.52deg, #08AC17 -8.14%, #4D71D0 81.48%)",
                  webkitBackgroundClip: "text",
                  webkitTextFillColor: "transparent",
                  backgroundClip: "text",
                  textFillColor: "transparent",
                  border: "2px solid #E5E7EB",
                  width: "fit-content",
                  padding: "8px 16px",
                  borderRadius: "100px",
                  marginTop: { xs: "36px", md: "24px 0" },
                }}
              >
                Our mission
              </Typography>
              <Typography
                component="h1"
                sx={{
                  fontSize: { xs: "28px", md: "40px" },
                  lineHeight: { xs: "36px", md: "56px" },
                  fontWeight: { xs: "700", md: "700" },
                  color: "#0A0C0F",
                  textAlign: "center",
                  margin: { xs: "auto 24px", md: "0" },
                }}
              >
                Create 60 Lakhs+ micro-entrepreneurs all over India
              </Typography>
              <Typography
                sx={{
                  fontSize: { xs: "16px", md: "20px" },
                  lineHeight: { xs: "24px", md: "32px" },
                  fontWeight: { xs: "500", md: "600" },
                  color: "#0A0C0F",
                  textAlign: "center",
                  margin: { xs: "0 24px", md: "0" },
                }}
              >
                By giving them a platform to earn by selling financial products
                within their trusted network
              </Typography>
            </Grid>
            <Grid sx={{ width: "100%", height: { xs: "30vh", md: "60vh" } }}>
              <Image
                src={AboutUsBg}
                alt="GroMo mission banner illustration"
                style={{ objectFit: "contain", width: "100%" }}
              />
            </Grid>
          </Grid>
          <Grid sx={{ padding: { xs: "", md: "80px 0 48px 0" } }}>
            <Typography
              sx={{
                textAlign: "center",
                fontSize: { xs: "18px", md: "20px" },
                lineHeight: { xs: "24px", md: "32px" },
                fontWeight: "500",
              }}
            >
              Values we swear by
            </Typography>
            <Grid
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                margin: "12px auto 24px auto",
              }}
            >
              {RECORD_LIST.map((item) => {
                return (
                  <Typography
                    sx={{
                      fontSize: { xs: "44px", md: "64px" },
                      lineHeight: { xs: "36px", md: "72px" },
                      fontWeight: "700",
                      margin: "0 8px",
                      color: item.color,
                    }}
                    key={item.title}
                  >
                    {item.text}
                  </Typography>
                );
              })}
            </Grid>

            <Grid
              sx={{
                margin: "36px auto",
                width: "80%",
                display: { xs: "block", md: "none" },
              }}
            >
              <Slider {...settingsRecord}>
                {RECORD_LIST.map((item) => {
                  return (
                    <Grid
                      sx={{
                        maxWidth: "450px",
                        height: { xs: "", md: "120px" },
                        display: "flex",
                        alignItems: "flex-start",
                        flexDirection: { xs: "column", md: "row" },
                        margin: { xs: "", md: "24px" },
                        justifyContent: { xs: "center", md: "normal" },
                        textAlign: { xs: "center", md: "" },
                      }}
                      key={item.color}
                    >
                      <Grid
                        sx={{
                          fontSize: { xs: "40px", md: "64px" },
                          lineHeight: { xs: "32px", md: "72px" },
                          fontWeight: "700",
                          height: "120px",
                          width: "120px",
                          display: "grid",
                          placeContent: "center",
                          borderRadius: "100px",
                          margin: "auto",
                          background: item.color,
                          color: "white",
                        }}
                      >
                        {item.text}
                      </Grid>
                      <Grid sx={{ padding: "8px 12px" }}>
                        <Typography
                          sx={{
                            fontSize: "24px",
                            lineHeight: "36px",
                            fontWeight: "700",
                          }}
                        >
                          {item.title}
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "18px",
                            lineHeight: "24px",
                            fontWeight: "400",
                            color: "#6C717F",
                          }}
                        >
                          {item.content}
                        </Typography>
                      </Grid>
                    </Grid>
                  );
                })}
              </Slider>
            </Grid>

            <Grid
              sx={{
                display: { xs: "none", md: "flex" },
                justifyContent: "center",
                width: "80%",
                margin: "24px auto",
                padding: "24px",
                maxWidth: "1440px",
              }}
            >
              <Grid>
                {RECORD_LIST.filter((item, i) => i < 3).map((item) => {
                  return (
                    <Grid
                      sx={{
                        maxWidth: "450px",
                        height: "120px",
                        display: "flex",
                        alignItems: "flex-start",
                        margin: { xs: "12px", md: "24px" },
                      }}
                      key={item.title}
                    >
                      <Grid
                        sx={{
                          fontSize: "32px",
                          lineHeight: "40px",
                          fontWeight: "700",
                          height: "120px",
                          minWidth: "120px",
                          display: "grid",
                          placeContent: "center",
                          borderRadius: "100px",
                          color: "white",
                          backgroundColor: item.color,
                        }}
                      >
                        {item.text}
                      </Grid>
                      <Grid sx={{ padding: "8px 12px" }}>
                        <Typography
                          sx={{
                            fontSize: "24px",
                            lineHeight: "36px",
                            fontWeight: "700",
                          }}
                        >
                          {item.title}
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "18px",
                            lineHeight: "24px",
                            fontWeight: "400",
                            color: "#6C717F",
                          }}
                        >
                          {item.content}
                        </Typography>
                      </Grid>
                    </Grid>
                  );
                })}
              </Grid>
              <Grid>
                {RECORD_LIST.filter((item, i) => i >= 3).map((item) => {
                  return (
                    <Grid
                      sx={{
                        maxWidth: "450px",
                        height: "120px",
                        display: "flex",
                        alignItems: "flex-start",
                        margin: { xs: "", md: "24px" },
                      }}
                      key={item.title}
                    >
                      <Grid
                        sx={{
                          fontSize: "32px",
                          lineHeight: "40px",
                          fontWeight: "700",
                          height: "120px",
                          minWidth: "120px",
                          display: "grid",
                          placeContent: "center",
                          borderRadius: "100px",
                          color: "white",
                          backgroundColor: item.color,
                        }}
                      >
                        {item.text}
                      </Grid>
                      <Grid sx={{ padding: "8px 12px" }}>
                        <Typography
                          sx={{
                            fontSize: "24px",
                            lineHeight: "36px",
                            fontWeight: "700",
                          }}
                        >
                          {item.title}
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "18px",
                            lineHeight: "24px",
                            fontWeight: "400",
                            color: "#6C717F",
                          }}
                        >
                          {item.content}
                        </Typography>
                      </Grid>
                    </Grid>
                  );
                })}
              </Grid>
            </Grid>
          </Grid>

          <Grid
            sx={{
              padding: { xs: "24px", md: "48px" },
              position: "relative",
              margin: "24px auto",
              maxWidth: "1440px",
            }}
          >
            <Typography
              sx={{
                textAlign: "center",
                fontSize: { xs: "24px", md: "40px" },
                lineHeight: { xs: "36px", md: "56px" },
                fontWeight: { xs: "700", md: "600" },
                margin: { xs: "", md: "8px 0" },
              }}
            >
              {/* Meet our team */}
              Meet Our Founders
            </Typography>

            <Grid
              sx={{
                display: { xs: "none", md: "flex" },
                flexWrap: "wrap",
                justifyContent: "center",
                alignItems: "center",
                margin: { xs: "24px auto", md: "36px auto" },
                width: "85%",
              }}
            >
              {TEAM_CARDS.map((item, i) => {
                return (
                  <Grid
                    sx={{
                      width: { xs: "100%", md: "350px" },
                      margin: "16px 8px",
                      zIndex: 2,
                      display: { xs: i > 3 ? "none" : "block", md: "block" },
                    }}
                    key={item.name}
                  >
                    <Grid
                      sx={{
                        width: "100%",
                        position: "relative",
                        border: "1px solid #DEE7FF",
                        borderRadius: "12px",
                      }}
                      id="card"
                    >
                      <Image
                        src={item.img || Ankit}
                        alt="AboutUsBg"
                        style={{ objectFit: "contain", borderRadius: "12px" }}
                      />
                      <Grid
                        id="cardText"
                        sx={{
                          position: "absolute",
                          height: "100%",
                          width: "100%",
                          inset: 0,
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: "20px",
                            fontWeight: "600",
                            padding: "12px 12px 0 12px",
                            color: "white",
                            textAlign: "center",
                          }}
                        >
                          {item.hoverText}
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "14px",
                            fontWeight: "400",
                            padding: "0 12px 12px 12px",
                            color: "white",
                            textAlign: "center",
                          }}
                        >
                          {item.hoverText2}
                        </Typography>
                      </Grid>
                    </Grid>
                    <Typography
                      sx={{
                        fontSize: { xs: "24px", md: "28px" },
                        lineHeight: "36px",
                        fontWeight: "700",
                        color: "#393F50",
                        margin: { xs: "4px 0", md: "8px 0" },
                      }}
                    >
                      {item.name}
                    </Typography>
                    <Grid>
                      <Link href={item.linkedIn} target="_blank">
                        <svg
                          width="35"
                          height="32"
                          viewBox="0 0 35 36"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          style={{
                            transform: "scale(.8)",
                          }}
                        >
                          <path
                            d="M32.5 0.5H2.42188C1.09375 0.5 0 1.67188 0 3.07812V33C0 34.4062 1.09375 35.5 2.42188 35.5H32.5C33.8281 35.5 35 34.4062 35 33V3.07812C35 1.67188 33.8281 0.5 32.5 0.5ZM10.5469 30.5H5.39062V13.8594H10.5469V30.5ZM7.96875 11.5156C6.25 11.5156 4.92188 10.1875 4.92188 8.54688C4.92188 6.90625 6.25 5.5 7.96875 5.5C9.60938 5.5 10.9375 6.90625 10.9375 8.54688C10.9375 10.1875 9.60938 11.5156 7.96875 11.5156ZM30 30.5H24.7656V22.375C24.7656 20.5 24.7656 18 22.1094 18C19.375 18 18.9844 20.1094 18.9844 22.2969V30.5H13.8281V13.8594H18.75V16.125H18.8281C19.5312 14.7969 21.25 13.3906 23.75 13.3906C28.9844 13.3906 30 16.9062 30 21.3594V30.5Z"
                            fill="#5377D7"
                          />
                        </svg>
                      </Link>
                    </Grid>
                  </Grid>
                );
              })}
            </Grid>

            <Grid
              sx={{
                display: { xs: "block", md: "none" },
                flexWrap: "wrap",
                justifyContent: "center",
                alignItems: "center",
                margin: { xs: "24px auto", md: "36px auto" },
                width: "85%",
              }}
            >
              <Slider {...settings}>
                {TEAM_CARDS.map((item, i) => {
                  return (
                    <Grid
                      sx={{
                        width: { xs: "100%", md: "30%" },
                        zIndex: 2,
                        padding: "10px",
                      }}
                      key={item.name}
                    >
                      <Grid
                        sx={{
                          width: "100%",
                          position: "relative",
                          border: "1px solid #DEE7FF",
                          borderRadius: "12px",
                        }}
                        id="card"
                      >
                        <Image
                          src={item.img || Ankit}
                          alt="AboutUsBg"
                          style={{ objectFit: "contain", borderRadius: "12px" }}
                        />
                        <Grid
                          id="cardText"
                          sx={{
                            position: "absolute",
                            height: "100%",
                            width: "100%",
                            inset: 0,
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: "20px",
                              fontWeight: "600",
                              padding: "12px 12px 0 12px",
                              color: "white",
                              textAlign: "center",
                            }}
                          >
                            {item.hoverText}
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "14px",
                              fontWeight: "400",
                              padding: "0 12px 12px 12px",
                              color: "white",
                              textAlign: "center",
                            }}
                          >
                            {item.hoverText2}
                          </Typography>
                        </Grid>
                      </Grid>
                      <Typography
                        sx={{
                          fontSize: { xs: "24px", md: "28px" },
                          lineHeight: "36px",
                          fontWeight: "700",
                          color: "#393F50",
                          margin: { xs: "4px 0", md: "8px 0" },
                        }}
                      >
                        {item.name}
                      </Typography>
                      <Grid>
                        <Link href={item.linkedIn} target="_blank">
                          <svg
                            width="35"
                            height="32"
                            viewBox="0 0 35 36"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{
                              transform: "scale(.8)",
                            }}
                          >
                            <path
                              d="M32.5 0.5H2.42188C1.09375 0.5 0 1.67188 0 3.07812V33C0 34.4062 1.09375 35.5 2.42188 35.5H32.5C33.8281 35.5 35 34.4062 35 33V3.07812C35 1.67188 33.8281 0.5 32.5 0.5ZM10.5469 30.5H5.39062V13.8594H10.5469V30.5ZM7.96875 11.5156C6.25 11.5156 4.92188 10.1875 4.92188 8.54688C4.92188 6.90625 6.25 5.5 7.96875 5.5C9.60938 5.5 10.9375 6.90625 10.9375 8.54688C10.9375 10.1875 9.60938 11.5156 7.96875 11.5156ZM30 30.5H24.7656V22.375C24.7656 20.5 24.7656 18 22.1094 18C19.375 18 18.9844 20.1094 18.9844 22.2969V30.5H13.8281V13.8594H18.75V16.125H18.8281C19.5312 14.7969 21.25 13.3906 23.75 13.3906C28.9844 13.3906 30 16.9062 30 21.3594V30.5Z"
                              fill="#5377D7"
                            />
                          </svg>
                        </Link>
                      </Grid>
                    </Grid>
                  );
                })}
              </Slider>
            </Grid>

            <Grid
              sx={{
                display: { xs: "none", md: "block" },
                position: "absolute",
                top: 0,
                right: 0,
                zIndex: 0,
              }}
            >
              <svg
                width="100%"
                height="800"
                viewBox="0 0 475 800"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  opacity="0.15"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M400 800C620.914 800 800 620.914 800 400C800 179.086 620.914 0 400 0C179.086 0 0 179.086 0 400C0 620.914 179.086 800 400 800ZM399.999 644.444C264.996 644.444 155.555 535.003 155.555 400C155.555 264.997 264.996 155.555 399.999 155.555C535.002 155.555 644.444 264.997 644.444 400C644.444 535.003 535.002 644.444 399.999 644.444Z"
                  fill="url(#paint0_linear_31322_266948)"
                />
                <defs>
                  <linearGradient
                    id="paint0_linear_31322_266948"
                    x1="377.604"
                    y1="-7.37655e-08"
                    x2="377.604"
                    y2="641.146"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#3366E8" stopOpacity="0.6" />
                    <stop offset="1" stopColor="#3366E8" stopOpacity="0.01" />
                  </linearGradient>
                </defs>
              </svg>
            </Grid>
            <Grid
              sx={{
                display: { xs: "none", md: "block" },
                position: "absolute",
                left: 0,
                top: "20%",
                bottom: "50%",
              }}
            >
              <svg
                width="100%"
                height="800"
                viewBox="0 0 400 800"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  opacity="0.15"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M-3.05176e-05 800C220.914 800 400 620.914 400 400C400 179.086 220.914 0 -3.05176e-05 0C-220.914 0 -400 179.086 -400 400C-400 620.914 -220.914 800 -3.05176e-05 800ZM-0.000854492 644.445C-135.004 644.445 -244.445 535.003 -244.445 400C-244.445 264.997 -135.004 155.556 -0.000854492 155.556C135.002 155.556 244.444 264.997 244.444 400C244.444 535.003 135.002 644.445 -0.000854492 644.445Z"
                  fill="url(#paint0_linear_31322_266951)"
                />
                <defs>
                  <linearGradient
                    id="paint0_linear_31322_266951"
                    x1="-22.3958"
                    y1="-7.37655e-08"
                    x2="-22.3958"
                    y2="641.146"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#3366E8" stopOpacity="0.01" />
                    <stop offset="1" stopColor="#3366E8" stopOpacity="0.6" />
                  </linearGradient>
                </defs>
              </svg>
            </Grid>
          </Grid>

          <Grid sx={{ margin: { xs: "72px 0", md: "120px 0" }, width: "100%" }}>
            <Image
              src={gromoTeam}
              alt="gromoTeam"
              style={{ objectFit: "contain", width: "100%" }}
            />
          </Grid>

          <Grid
            sx={{
              padding: { xs: "", md: "24px" },
              maxWidth: "1440px",
              margin: "auto",
            }}
          >
            <Typography
              sx={{
                fontSize: { xs: "24px", md: "40px" },
                lineHeight: { xs: "36px", md: "56px" },
                fontWeight: { xs: "700", md: "600" },
                color: "#0A0C0F",
                textAlign: "center",
              }}
            >
              Our investors
            </Typography>
            {/* <Typography
              sx={{
                textAlign: "center",
                fontSize: { xs: "16px", md: "20px" },
                lineHeight: { xs: "24px", md: "32px" },
                fontWeight: { xs: "500", md: "400" },
                color: "#393F50",
                margin: " 0 24px",
              }}
            >
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
              vulputate libero et <br /> velit interdum, ac aliquet odio mattis.
              Class aptent taciti sociosqu ad.
            </Typography> */}

            <Grid
              sx={{
                width: { xs: "85%", md: "70%" },
                margin: "24px auto",
              }}
            >
              <Slider ref={investorsIconsRef} {...settingsInvestorsIcon}>
                {INVESTOR_ICONS.map((item, i) => {
                  return (
                    <Grid
                      sx={{
                        padding: "0 12px",
                      }}
                      key={i}
                    >
                      <Image
                        src={item.img}
                        alt="investors"
                        style={{ objectFit: "contain", borderRadius: "12px" }}
                      />
                    </Grid>
                  );
                })}
              </Slider>
            </Grid>

            <Grid
              sx={{
                width: "80%",
                margin: "24px auto",
              }}
            >
              <Slider ref={investorsImagesRef} {...settingsInvestorImage}>
                {INVESTORS_IMAGES.map((item, i) => {
                  return (
                    <Grid
                      sx={{
                        padding: "0 12px",
                      }}
                      key={i}
                    >
                      <Image
                        src={item.img}
                        alt="investorImg"
                        style={{ objectFit: "contain", borderRadius: "12px" }}
                      />
                    </Grid>
                  );
                })}
              </Slider>
            </Grid>
          </Grid>

          <Grid
            sx={{
              width: "100%",
              height: { xs: "content-fit", md: "75vh" },
              backgroundImage: {
                xs: "",
                md: `linear-gradient(286.03deg, rgba(0, 0, 0, 0.1) 50.86%, rgba(0, 0, 0, 0) 88.16%), url(${openPositionBg.src})`,
              },
              backgroundPosition: { xs: "top", md: "center" },
              backgroundRepeat: "no-repeat",
              backgroundSize: { xs: "contain", md: "cover" },
              position: "relative",
              display: { xs: "flex", md: "grid" },
              flexDirection: "column",
              gridTemplateColumns: "1fr 1fr",
              placeContent: "center",
              margin: "48px 0",
              justifyContent: { xs: "center" },
              alignItems: { xs: "end" },
            }}
          >
            <Grid
              sx={{
                color: "white",
                width: { xs: "", md: "450px" },
                marginLeft: "16%",
                display: { xs: "none", md: "block" },
              }}
            >
              <Typography
                sx={{
                  fontSize: { xs: "", md: "40px" },
                  lineHeight: { xs: "", md: "56px" },
                  fontWeight: { xs: "", md: "400" },
                  margin: { xs: "", md: "8px" },
                  padding: "8px",
                }}
              >
                We love working here. <br />
                We think you will too.
              </Typography>
              <Typography
                sx={{
                  fontSize: { xs: "", md: "18px" },
                  lineHeight: { xs: "", md: "24px" },
                  fontWeight: { xs: "", md: "500" },
                  margin: { xs: "", md: "8px" },
                  padding: "8px",
                }}
              >
                We believe people can do remarkable work. They can push
                boundaries, solve problems and making something real. <br />
                <br />
                If you have these amazing capabilities, we have a job for you.
              </Typography>
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#08AC17",
                  color: "white",
                  "&:hover": {
                    backgroundColor: "#08AC17",
                  },
                  padding: { xs: "", md: "12px 24px" },
                  borderRadius: "4px",
                  margin: { xs: "", md: "16px" },
                }}
                onClick={() => (window.location.href = "/career")}
              >
                See open positions
              </Button>
            </Grid>
            <Grid sx={{ display: { xs: "block", md: "none" } }}>
              <Image
                src={openPositionBg}
                alt="Open Position Background"
                style={{
                  width: "100%",
                  objectFit: "contain",
                }}
              />
            </Grid>
            <Grid
              sx={{
                width: { xs: "100%", md: "450px" },
                marginLeft: { xs: "0", md: "10%" },
                padding: "24px",
                display: { xs: "block", md: "none" },
                background: "white",
              }}
            >
              <Typography
                sx={{
                  fontSize: { xs: "28px", md: "40px" },
                  lineHeight: { xs: "36px", md: "56px" },
                  fontWeight: { xs: "700", md: "400" },
                  margin: { xs: "8px 0", md: "16px" },
                }}
              >
                We love working here. <br />
                We think you will too.
              </Typography>
              <Typography
                sx={{
                  fontSize: "18px",
                  lineHeight: "24px",
                  fontWeight: { xs: "400", md: "500" },
                  margin: { xs: "8px 0", md: "16px" },
                }}
              >
                We believe people can do remarkable work. They can push
                boundaries, solve problems and making something real. <br />
                <br />
                If you have these amazing capabilities, we have a job for you.
              </Typography>
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#08AC17",
                  color: "white",
                  "&:hover": {
                    backgroundColor: "#08AC17",
                  },
                  padding: { xs: "", md: "12px 24px" },
                  borderRadius: "4px",
                  margin: { xs: "", md: "16px" },
                }}
              >
                <Link href="/careers">See open positions</Link>
              </Button>
            </Grid>
          </Grid>
        </>
      </AppWrapperContainer>
      <AppFooter />
    </>
  );
}

export default AboutUs;
